// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../index';

import { gql } from 'graphql-tag';
export const SignatureStoneInputFragmentDoc = gql`
    fragment signatureStoneInput on CatalogueEngagementRingSignatureStone {
  __typename
  color {
    systemCode
  }
  crystal {
    systemCode
  }
  width
}
    `;